import { Injectable } from '@angular/core';
import { CONSTANTS } from '../constants';

@Injectable({
  providedIn: 'root'
})

export class StrategyHelper {

    toUsRow(us: any) {
        let entry_exit_time: any = '';
        if (us['settings']['entry_time'] && us['settings']['entry_time'] != '') {
          entry_exit_time = us['settings']['entry_time'];
        }
        if (us['settings']['exit_time'] && us['settings']['exit_time'] != '') {
          if (entry_exit_time != "") {
            entry_exit_time += '/';
          }
          entry_exit_time += us['settings']['exit_time'];
        }
        return {
          'id': us['_id'],
          'strategy_name': us['display_name'],
          'dname_edit': {
            'edit': false,
            'text': us['display_name']
          },
          'symbol': us['settings']['symbol'],
          'broker': `${us['ba']['name']}/${us['ba']['client_id']}`,
          'state': us['state'],
          'entry_time': us['settings']['entry_time'],
          'exit_time': us['settings']['exit_time'],
          'entry_exit_time': entry_exit_time,
          'enabled': (us['status'] == 'enabled'),
          'show_status': true,
          'strategy_state': this.strategyStateClass(us['state']),
          'restart_state': '',
          'edit_state': '',
          'delete_state': { 'text-danger': 1 },
          'original': us
        }
    }

    strategyStateClass(state: any) {
        if (state == 'stopped') {
          return { 'bi-stop-fill': 0, 'text-danger': 0, 'bi-play-fill': 1, 'text-success': 1 }
        } else {
          return { 'bi-stop-fill': 1, 'text-danger': 1, 'bi-play-fill': 0, 'text-success': 0 }
        }
    }

    getDefaultSettings(strategy: any, symbol: any, ba: any, user: any): any {
        if (strategy.name.toLowerCase() == 'lss_v1') {
            return this.getLssV1DefaultSettings(strategy, symbol, ba, user);
        } else if (strategy.name.toLowerCase() == 'orb_v1') {
          return this.getOrbV1DefaultSettings(strategy, symbol, ba, user);
        }
    }

    getLssV1DefaultSettings(strategy: any, symbol: any, ba: any, user: any) {
        let original: any = {
            strategy: strategy,
            ba: ba.original,
            user: user,
            script: 'internal',
            script_details: {},
            status: 'disabled',
            settings: {
                category: 'INDEX',
                segment: 'SPOT',
                symbol: symbol,
                strike_diff: symbol.instrument.option_details.strike_diff,
                run_mode: 'live',
                tgt: {
                    state: 'disabled',
                    type: '',
                    value: 0
                },
                sl: {
                    state: 'disabled',
                    type: '',
                    value: 0
                },
                tsl: {
                    state: 'disabled',
                    type: '',
                    value: 0
                },
                strike_selection: {
                    type: 'default',
                    value: {
                      ce: 0,
                      pe: 0
                    }
                },
                straddle_type: 'buy',
                lots: 1,
                days: CONSTANTS.DAYS,
                trade_type: 'mis',
                timeframe: 'minute',
                interval: 1,
                entry_time: '09:20',
                exit_time: '15:15',
                reenter: {
                    state: 'disabled',
                    on: "",
                    count: 0,
                }
            }
        }
        return {
            'strategy_name': strategy.display_name,
            'dname_edit': {
              'edit': false,
              'text': strategy.display_name
            },
            'symbol': original.settings.symbol,
            'broker': `${ba['name']}/${ba['client_id']}`,
            'state': CONSTANTS.STRATEGY_STATES.STOPPED,
            'entry_time': original.start_time,
            'exit_time': original.exit_time,
            'entry_exit_time': '09:20/15:15',
            'enabled': (original['state'] == 'enabled'),
            'show_status': false,
            'strategy_state': this.strategyStateClass(CONSTANTS.STRATEGY_STATES.STOPPED),
            'restart_state': '',
            'edit_state': '',
            'delete_state': { 'text-danger': 1 },
            'original': original
        }
    }

    getOrbV1DefaultSettings(strategy: any, symbol: any, ba: any, user: any) {
      let original: any = {
          strategy: strategy,
          ba: ba.original,
          user: user,
          script: 'internal',
          script_details: {},
          status: 'disabled',
          settings: {
              category: 'INDEX',
              segment: 'SPOT',
              symbol: symbol,
              strike_diff: symbol.instrument.option_details.strike_diff,
              run_mode: {
                which: 'live',
                value: {
                  telegram_id: ''
                }
              },
              tgt: {
                  state: 'disabled',
                  type: '',
                  value_type: '',
                  value: 0
              },
              sl: {
                  state: 'disabled',
                  type: '',
                  value_type: '',
                  value: 0
              },
              tsl: {
                  state: 'disabled',
                  type: '',
                  value: 0
              },
              strike_selection: {
                  segment: 'spot',
                  type: 'default',
                  value: {
                    min: 0,
                    max: 0
                  }
              },
              entry_side: 'buy',
              lots: 1,
              days: CONSTANTS.DAYS,
              trade_type: 'mis',
              timeframe: 'minute',
              interval: 1,
              entry_time: '09:20',
              buffer_time: '15:00',
              exit_time: '15:15',
              reenter: {
                  state: 'disabled',
                  on: "",
                  what: "",
                  freq: "",
                  count: 0,
              },
              order_adjustment: {
                state: 'disabled',
                sl: {
                  state: 'disabled',
                  type: ''
                },
                tgt: {
                  state: 'disabled',
                  type: ''
                }
              }
          }
      }
      return {
          'strategy_name': strategy.display_name,
          'dname_edit': {
            'edit': false,
            'text': strategy.display_name
          },
          'symbol': original.settings.symbol,
          'broker': `${ba['name']}/${ba['client_id']}`,
          'state': CONSTANTS.STRATEGY_STATES.STOPPED,
          'entry_time': original.start_time,
          'exit_time': original.exit_time,
          'entry_exit_time': '09:20/15:15',
          'enabled': (original['state'] == 'enabled'),
          'show_status': false,
          'strategy_state': this.strategyStateClass(CONSTANTS.STRATEGY_STATES.STOPPED),
          'restart_state': '',
          'edit_state': '',
          'delete_state': { 'text-danger': 1 },
          'original': original
      }
  }
}
